export default {
  monthlyPrice: {
    id: 'catch_up_modal_offer_insurance_monthly_price',
    defaultMessage: '{price}/month',
  },
}
